import type { Action } from "../actions.types";

/**
 * Get action by type slug.
 */
export function getAction(actions: Action[], slug: string): Action | undefined {
  return actions.find((a) => a.action_type?.slug === slug);
}

